exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feed_back-modal .modal-dialog{max-width:760px;margin:1.75rem auto}.feed_back-modal .modal-content{border:none;border-radius:16px;background:transparent;box-shadow:0 24px 56px rgba(18,40,63,.2),0 8px 16px rgba(18,40,63,.08);overflow:hidden;padding:0!important}.feed_back-modal .modal-body{padding:0!important}html.dark .feed_back-modal .modal-content{background:transparent}", ""]);

// exports
